<script>
	/* eslint-disable svelte/no-at-html-tags */
	export let errors = {};
	export let label = '';
	export let name = '';
	export let lock_operator = false;
	export let operator;
	export let available_operators;
	export let value;
	export let disabled = false;
	export let value_between = undefined;
	export let between = true;

	import SelectInput from '@/Components/SelectInput.svelte';
	import TextInput from '@/Components/NewTextInput.svelte';

	// eslint-disable-next-line no-unused-vars
	$: props = (({ label, name, value, errors, style, disabled, between, ...rest }) => rest)($$props);
</script>

<div class="flex flex-col w-1/4 border-r first:border-l first:pl-1">
	<div class="flex flex-row w-full">
		<h1 class="mb-1">{label}</h1>
	</div>
	<div class="flex flex-row items-end text-sm">
		<SelectInput
			className="w-24"
			name={name + '.operator'}
			errors={errors && errors['user_criteria.' + name + '.operator']}
			readonly={lock_operator}
			bind:value={operator}
			{disabled}
		>
			<option value={null} selected>N/A</option>
			{#if available_operators}
				{#each Object.keys(available_operators) as operator}
					<option value={operator}> {@html available_operators[operator]}</option>
				{/each}
			{:else}
				<option value=">">&gt;</option>
				<option value=">=">&gt;&equals;</option>
				<option value="=">&equals;</option>
				<option value="<">&lt;</option>
				<option value="<=">&lt;&equals;</option>
				{#if between}
					<option value="between">Between</option>
				{/if}
			{/if}
		</SelectInput>
		<TextInput
			className={operator == 'between' ? 'pl-1 pr-0.5 w-20' : 'pl-1 pr-0.5 w-30'}
			name={name + '.value'}
			errors={errors && errors['user_criteria.' + name + '.value']}
			disabled={(operator == null && disabled == false) || disabled == true}
			required={operator != null}
			{...props}
			bind:value
		/>
		{#if operator == 'between'}
			<div class="flex flex-row justify-center items-center pb-3">AND</div>
			<TextInput
				className="w-20 pl-0.5 pr-1"
				name={name + '.value_between'}
				errors={errors && errors['user_criteria.' + name + '.value_between']}
				disabled={(operator == null && disabled == false) || disabled == true}
				required={operator == 'between'}
				{...props}
				bind:value={value_between}
			/>
		{/if}
	</div>
</div>
